export default __webpack_public_path__ + "static/media/MiniaturaAffinity.a95488f6.jpg";